/* Premium Product Card JavaScript */

document.addEventListener('DOMContentLoaded', function() {
  // Global Event Delegation Helper
  function delegateEvent(eventType, selector, handler) {
    document.body.addEventListener(eventType, function(event) {
      const target = event.target.closest(selector);
      if (target) handler.call(target, event);
    });
  }

  // Helper to format price based on original format
  function formatPrice(cents, originalText) {
    if (!originalText) return '';
    // Find the numeric portion (digits, commas, periods, spaces)
    const match = originalText.match(/([0-9\s.,]+)/);
    if (!match) return originalText;
    
    const originalNumStr = match[0];
    const prefix = originalText.split(originalNumStr)[0] || '';
    const suffix = originalText.split(originalNumStr)[1] || '';
    
    // Check if the original price text contains commas or decimals
    const hasDecimal = originalText.includes('.') || originalText.includes(',');
    
    // Format the cents value
    let formattedVal = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    // If the original used comma as decimal (e.g., European formats like 19,99)
    if (originalText.includes(',') && !originalText.includes('.')) {
      formattedVal = formattedVal.replace('.', ',');
    }
    
    return prefix + formattedVal + suffix;
  }

  // 1. Variant size pill click handler
  delegateEvent('click', '.premium-size-pills .size-pill', function(e) {
    e.preventDefault();
    if (this.classList.contains('disabled') || this.classList.contains('active')) return;

    const sizeSelector = this.closest('.premium-size-selector');
    const optionIndex = parseInt(sizeSelector.getAttribute('data-option-index'), 10);
    const card = this.closest('.product_card');
    
    // Set active class on pill
    sizeSelector.querySelectorAll('.size-pill').forEach(pill => pill.classList.remove('active'));
    this.classList.add('active');

    // Read all selected options on this card
    const selectedOptions = [];
    
    // Size option (from the pills)
    selectedOptions[optionIndex] = this.getAttribute('data-value');
    
    // Check if color swatch option exists and is selected
    const activeColorSwatch = card.querySelector('.color-swatch.active');
    if (activeColorSwatch) {
      const colorSelector = activeColorSwatch.closest('.ProductItem__ColorSwatchList');
      // Shopify swatches are usually option1, option2 or option3. Let's inspect options.
      // We can map option values to find matching variants
    }

    // Load variant JSON data
    const variantsJsonEl = card.querySelector('.product-variants-json');
    if (!variantsJsonEl) return;
    
    try {
      const variants = JSON.parse(variantsJsonEl.textContent);
      const selectedValue = this.getAttribute('data-value');
      
      // Find matching variant based on size value (and active color if applicable)
      // Usually size is the only variant selection on grid, or color is handled via swatch links.
      // Let's find variant where option matches.
      let matchingVariant = null;
      
      // If there are color swatches, check the active color value
      const activeColor = card.querySelector('.color-swatch.active span')?.getAttribute('title') || 
                           card.querySelector('.color-swatch.active')?.getAttribute('title');

      // Loop to match variant options
      for (const variant of variants) {
        let isMatch = true;
        
        // Match the size option
        if (variant.options[optionIndex] !== selectedValue) {
          isMatch = false;
        }
        
        // If a color is active, match it too (if variant has color option)
        if (isMatch && activeColor) {
          const colorOptionIndex = variant.options.findIndex(opt => opt === activeColor);
          if (colorOptionIndex !== -1 && variant.options[colorOptionIndex] !== activeColor) {
            isMatch = false;
          }
        }
        
        if (isMatch) {
          matchingVariant = variant;
          break;
        }
      }
      
      // Fallback: If no exact match (due to color mismatch), just match the size first available
      if (!matchingVariant) {
        matchingVariant = variants.find(v => v.options[optionIndex] === selectedValue);
      }
      
      if (matchingVariant) {
        // Update input ID
        const idInput = card.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = matchingVariant.id;
          idInput.removeAttribute('disabled');
        }
        
        // Update Buy Now button attribute
        const buyNowBtn = card.querySelector('.btn-buy-now');
        if (buyNowBtn) {
          buyNowBtn.setAttribute('data-variant-id', matchingVariant.id);
        }

        // Update buttons state based on availability
        const addToCartBtn = card.querySelector('.btn-add-to-cart');
        const qtyCol = card.querySelector('.premium-qty-col');
        const buttonsRow = card.querySelector('.premium-buttons-row');
        
        if (matchingVariant.available) {
          if (addToCartBtn) {
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.classList.remove('btn-sold-out');
            addToCartBtn.style.display = '';
          }
          if (buyNowBtn) {
            buyNowBtn.removeAttribute('disabled');
            buyNowBtn.style.display = '';
          }
          
          // Show quantity selector
          if (qtyCol) {
            qtyCol.style.display = '';
            // Ensure qty selector exists
            let qtySelector = qtyCol.querySelector('.premium-qty-selector');
            if (!qtySelector) {
              qtySelector = document.createElement('div');
              qtySelector.className = 'premium-qty-selector';
              qtySelector.innerHTML = `
                <button type="button" class="qty-btn qty-minus" aria-label="Decrease quantity">-</button>
                <input type="number" name="quantity" class="qty-input" value="1" min="1" step="1" readonly>
                <button type="button" class="qty-btn qty-plus" aria-label="Increase quantity">+</button>
              `;
              qtyCol.appendChild(qtySelector);
            }
          }
          
          // Remove any single sold-out button if we created one
          const singleSoldOutBtn = buttonsRow ? buttonsRow.querySelector('.btn-sold-out') : null;
          if (singleSoldOutBtn) {
            singleSoldOutBtn.remove();
          }
          
          // Show form if hidden
          const form = buttonsRow ? buttonsRow.querySelector('product-form') : null;
          if (form) form.style.display = '';
        } else {
          // Sold out state
          if (addToCartBtn) addToCartBtn.style.display = 'none';
          if (buyNowBtn) buyNowBtn.style.display = 'none';
          
          // Hide quantity selector
          if (qtyCol) qtyCol.style.display = 'none';
          
          const form = buttonsRow ? buttonsRow.querySelector('product-form') : null;
          if (form) form.style.display = 'none';
          
          // Ensure we have a Sold Out button
          let singleSoldOutBtn = buttonsRow ? buttonsRow.querySelector('.btn-sold-out') : null;
          if (buttonsRow && !singleSoldOutBtn) {
            singleSoldOutBtn = document.createElement('button');
            singleSoldOutBtn.className = 'premium-btn btn-sold-out';
            singleSoldOutBtn.type = 'button';
            singleSoldOutBtn.disabled = true;
            singleSoldOutBtn.style.width = '100%';
            singleSoldOutBtn.innerHTML = `<span>${window.variantStrings?.soldOut || 'Sold Out'}</span>`;
            buttonsRow.appendChild(singleSoldOutBtn);
          }
        }

        // Update Price display
        const priceContainer = card.querySelector('.price');
        if (priceContainer) {
          const regularPriceEl = priceContainer.querySelector('.price-item--regular');
          const salePriceEl = priceContainer.querySelector('.price-item--sale');
          
          if (matchingVariant.compare_at_price > matchingVariant.price) {
            priceContainer.classList.add('price--on-sale');
            if (salePriceEl) {
              salePriceEl.textContent = formatPrice(matchingVariant.price, salePriceEl.textContent);
            }
            if (regularPriceEl) {
              regularPriceEl.textContent = formatPrice(matchingVariant.compare_at_price, regularPriceEl.textContent);
            }
          } else {
            priceContainer.classList.remove('price--on-sale');
            if (regularPriceEl) {
              regularPriceEl.textContent = formatPrice(matchingVariant.price, regularPriceEl.textContent);
            }
          }
        }
      }
    } catch (err) {
      console.error('Error updating product card variant:', err);
    }
  });

  // 2. Buy Now button click handler
  delegateEvent('click', '.btn-buy-now', function(e) {
    e.preventDefault();
    const btn = this;
    if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    
    // Add loading class to adjacent Add to Cart button to prevent double action
    const card = btn.closest('.product_card');
    const addToCartBtn = card.querySelector('.btn-add-to-cart');
    if (addToCartBtn) addToCartBtn.setAttribute('disabled', 'true');

    // Get selected quantity
    const qtyInput = card.querySelector('.qty-input');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    // Call Shopify Add to Cart AJAX API
    fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      // Direct redirect to checkout
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.error('Buy Now checkout redirect fallback:', err);
      window.location.href = '/checkout';
    })
    .finally(() => {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      if (addToCartBtn) addToCartBtn.removeAttribute('disabled');
    });
  });

  // 3. Quantity decrease click handler
  delegateEvent('click', '.qty-minus', function(e) {
    e.preventDefault();
    const qtyWrapper = this.closest('.premium-qty-selector');
    if (!qtyWrapper) return;
    const input = qtyWrapper.querySelector('.qty-input');
    if (!input) return;
    let currentVal = parseInt(input.value, 10) || 1;
    if (currentVal > 1) {
      const newVal = currentVal - 1;
      input.value = newVal;
      
      // Update hidden mirror input in form
      const card = this.closest('.product_card');
      const mirrorInput = card ? card.querySelector('.qty-mirror-input') : null;
      if (mirrorInput) mirrorInput.value = newVal;
    }
  });

  // 4. Quantity increase click handler
  delegateEvent('click', '.qty-plus', function(e) {
    e.preventDefault();
    const qtyWrapper = this.closest('.premium-qty-selector');
    if (!qtyWrapper) return;
    const input = qtyWrapper.querySelector('.qty-input');
    if (!input) return;
    let currentVal = parseInt(input.value, 10) || 1;
    const newVal = currentVal + 1;
    input.value = newVal;
    
    // Update hidden mirror input in form
    const card = this.closest('.product_card');
    const mirrorInput = card ? card.querySelector('.qty-mirror-input') : null;
    if (mirrorInput) mirrorInput.value = newVal;
  });
});
